<script setup>
import { ref } from 'vue';
import { trans } from '../../../../_00_elements/translation';
import Panel from '../../../../_02_molecules/components/Panel.vue';

const isChecked = ref(false);

const emit = defineEmits([ 'next-step' ]);
</script>

<template>
  <div class="recurring-payment">
    <span class="recurring-payment__title">
      {{ trans('gestion.subscription.step.0.title') }}
    </span>
    <div class="recurring-payment__contract-question">
      <span class="recurring-payment__question-text">
        {{ trans('gestion.subscription.step.0.question') }}
      </span>
      <panel
        class="recurring-payment__warning-panel"
        type="warning"
        :title="trans('gestion.subscription.step.0.panel.title')"
        :content="trans('gestion.subscription.step.0.panel.text')"
        icon="ph_warning-fill_yellow"
      />
      <div class="recurring-payment__confirmation">
        <input
          id="confirm-signature"
          v-model="isChecked"
          type="checkbox"
          class="recurring-payment__checkbox"
        >
        <label for="confirm-signature" class="recurring-payment__checkbox-label">
          {{ trans('gestion.subscription.step.0.checkbox') }}
        </label>
      </div>
      <button
        class="recurring-payment__next-button btn btn--primary"
        :disabled="!isChecked"
        @click="emit('next-step')"
      >
        {{ trans('global.pagination.next') }}
      </button>
    </div>
  </div>
</template>
